document.addEventListener("click", function (e) {
    if (e.target.matches(".upsell-add-product")){
        const variantId = e.target.dataset.variantId;
        
        fetch("/cart/add.js",{
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(() => fetch("/?sections=cart-drawer"))
        .then(res => res.json())
        .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data['cart-drawer'], 'text/html');
            const newCartDrawerInner = html.querySelector('#CartDrawer');

            const cartDrawer = document.querySelector('cart-drawer');
            const cartDrawerInner = cartDrawer?.querySelector('#CartDrawer');
            const drawer = document.querySelector('.drawer');

            if (cartDrawer && cartDrawerInner && newCartDrawerInner) {
                cartDrawerInner.innerHTML = newCartDrawerInner.innerHTML;
                // window.initializeCartCustomSelects();

                drawer?.classList.add('active');
                document.body.classList.add('overflow-hidden');
            }

            // const newItems = doc.querySelector("#CartDrawer-CartItems");
            // const currentItems = document.querySelector("#CartDrawer-CartItems");

            // if (newItems && currentItems) {
            //     currentItems.innerHTML = newItems.innerHTML;
            //     console.log();
            // } else {
            //     console.warn("CartDrawer-CartItems not found!");
            // }
        });
    }

});